<app-infobox [pointData]="pointData" [penetration]="penetration"></app-infobox>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/widgets/value/scontrino-medio-carta-indicator/scontrino-medio-carta-indicator.component.html